import { Icons } from '@/components/icons';
import { Button } from '@/components/primitives/Button';
import { TransText } from '@/i18n/trans/text';
import { breakpoints } from '@/utils/breakpoints';
import type { FC } from 'react';
import { useMediaQuery } from 'react-responsive';

interface RefundModalSelectionFooterProps {
  handleClose: () => void;
  handleInitiateRefund: () => void;
  selected: number;
  loading: boolean;
}

const RefundModalSelectionFooter: FC<RefundModalSelectionFooterProps> = ({
  handleClose,
  handleInitiateRefund,
  selected,
  loading,
}) => {
  const isLaptopOrBigger = useMediaQuery({
    minWidth: breakpoints.laptop,
  });

  return (
    <div className="flex gap-2">
      <Button
        variant="tertiary"
        data-testid="cancel-refund-btn"
        onClick={handleClose}
        className="rounded-lg laptop:w-auto"
        size={isLaptopOrBigger ? 'regular' : 'large'}
        fullWidth
      >
        <TransText i18nKey="cancel" />
      </Button>
      <Button
        data-testid="continue-refund-btn"
        onClick={handleInitiateRefund}
        disabled={!selected || loading}
        className="rounded-lg laptop:w-auto"
        size={isLaptopOrBigger ? 'regular' : 'large'}
        fullWidth
      >
        <TransText i18nKey="continue" />
        <Icons.arrowRight
          height={isLaptopOrBigger ? 16 : 24}
          width={isLaptopOrBigger ? 16 : 24}
        />
      </Button>
    </div>
  );
};

export default RefundModalSelectionFooter;
